import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Switch,
  IconButton,
  Input,
  TextField,
} from "@mui/material";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import InfinityCard from "../components/InfinityCard";
import CharacterCard from "../components/CharacterCard";
import { db } from "../@shared/firebase/config";
import { MainContext } from "../App";
import NeoButton from "../components/NeoButton";
import { useNavigate } from "react-router-dom";
import bg from "../@shared/assets/deckbuilderbg.png";
import {
  addToDeck,
  removeFromDeck,
  saveDeckToFirebase,
} from "../@shared/game/deckEngine";
import { useCardStore } from "../@shared/store/useCardsStore";
import { useAuthStore } from "../@shared/store/useAuthStore";
import Toast from "../components/Toast";
import { ArrowBackIos } from "@mui/icons-material";

const DeckBuilder = ({
  reset,
  setScreen,
  // cards,
  prevDeck,
  name,
  color,
  deckID,
}) => {
  const { infinityCards, characterCards } = useCardStore();
  const { userData } = useAuthStore();
  const { cards } = userData;

  const { Theme, setMessage, setError, setInfo, setSuccess } =
    React.useContext(MainContext);

  const [selectedCards, setSelectedCards] = useState([]);
  const [character, setCharacter] = useState(null);
  const [showCharacter, setShowCharacter] = useState(false);

  const [newDeck, setNewDeck] = useState(prevDeck ?? []);
  const [deckName, setDeckName] = useState(name ?? "");
  const [selectedDeckID, setSelectedDeckID] = useState(deckID ?? null);
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const [deckColor, setDeckColor] = useState(color ?? "#000000");
  const [showColorPicker, setShowColorPicker] = useState(false);

  const availableCardsRef = useRef(null);
  const deckCardsRef = useRef(null);

  const handleSelectCard = (card) => {
    // When in character view, update the character state instead of adding to deck.
    if (showCharacter) {
      setCharacter(card);
      return;
    }
    const countInDeck = selectedCards.filter(
      (c) => c.name === card.name
    ).length;
    const inventory = cards;
    const countInInventory = inventory.filter(
      (c) => c.name === card.name
    ).length;

    if (countInDeck >= card.max || countInDeck >= countInInventory) {
      console.log("Can't add more of this card.");
      return;
    }
    addToDeck(inventory, card, selectedCards, setSelectedCards);
  };

  const handleRemoveCard = (card) => {
    // When in character view, remove the character.
    if (showCharacter && character && card.name === character.name) {
      setCharacter(null);
    } else {
      removeFromDeck(card, selectedCards, setSelectedCards);
    }
  };

  const resetDeck = () => {
    setSelectedCards([]);
    setDeckName("");
    setCharacter(null);
  };

  const handleSaveDeck = async () => {
    setMessage("Saving deck...");
    setInfo(true);

    const res = await saveDeckToFirebase(
      userData,
      deckName,
      deckColor,
      newDeck,
      selectedDeckID,
      resetDeck
    );

    if (res) {
      console.warn("THIS IS THE RES", res);
      if (res.success) {
        setMessage(res.message);
        setSuccess(true);
        setTimeout(() => {
          setScreen("Decks");
        }, 2500);
      } else {
        setMessage(res.message);
        setError(true);
      }
    }
  };

  // Build deck preview slots.
  // If in character view, reserve the first slot for the character, then fill with infinity cards.
  let slots = [];
  for (let i = 1; i < 40; i++) {
    slots = Array.from({ length: 40 }, (_, index) => newDeck?.[index] || null);

    console.log("slots:", slots);
  }

  const cardCount = newDeck.reduce((acc, card) => {
    acc[card.id] = (acc[card.id] || 0) + 1;
    return acc;
  }, {});

  // Determine available cards based on toggle.
  const availableCards = showCharacter ? characterCards : cards;

  return (
    <Box
      sx={{
        height: "100%",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflowY: { xs: "scroll", md: "hidden" },
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <Toast onFinish={() => {}} timeTilClose={1500} />
      {/* Header */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 3,
          backgroundColor: Theme.palette.primary.main,
          borderBottom: `5px solid ${Theme.palette.primary.dark}`,
          borderTop: `5px solid ${Theme.palette.primary.light}`,
          position: "relative",
          width: "100%",
          pt: 2,
          pb: 2,
          height: "50px",
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "2%",
            transform: "translate(0%, -50%)",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NeoButton
            isIcon={true}
            icon={
              <ArrowBackIos
                style={{
                  color: Theme.palette.text.main,
                  fontSize: "1.5rem",
                  paddingLeft: "10px",
                }}
              />
            }
            borderRadius={10}
            onClick={() => setScreen("Decks")}
            color={Theme.palette.tirciary.main}
          />
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2rem", md: "3rem" },
            position: "relative",
            color: Theme.palette.text.main,
            textShadow: ` -2px -2px 0 ${Theme.palette.tirciary.dark}, 2px -2px 0 ${Theme.palette.tirciary.dark}, -2px  2px 0 ${Theme.palette.tirciary.dark}, 2px  2px 0 ${Theme.palette.tirciary.dark}`,
          }}
        >
          Build
        </Typography>

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            right: "2%",
            transform: "translate(0%, -50%)",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: { xs: "100px", md: "150px" },
          }}
        >
          <NeoButton
            onClick={handleSaveDeck}
            width={100}
            text="Save"
            color={Theme.palette.tirciary.main}
          />
        </Box>
      </Box>

      <Grid
        item
        container
        xs={12}
        sx={{
          display: "flex",
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          type="text"
          placeholder="Deck Name"
          variant="filled"
          size="small"
          value={deckName}
          onChange={(event) => setDeckName(event.target.value)}
          sx={{
            borderRadius: "3px",
            width: { xs: "60%", md: "50%" },
            input: {
              color: "#000",
            },
            label: {
              color: "#999",
            },
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
              "&:hover": {
                backgroundColor: "#fff",
              },
              "&:before": {
                borderBottomColor: "#ccc",
              },
              "&:hover:before": {
                borderBottomColor: "#ccc",
              },
            },
          }}
        />
        <NeoButton
          onClick={() => setShowColorPicker(true)}
          width={8}
          text="Pick Color"
          color={deckColor || Theme.palette.tirciary.main}
          sx={{
            // right: { xs: "2%", md: "3%" },
            // marginHorizontal: 10,
            position: "relative",
          }}
        />
        {/* <Button
          onClick={() => setShowColorPicker(true)}
          sx={{
            width: 100,
            height: 50,
            borderRadius: 50,
            borderWidth: 4,
            borderColor: "#000",
            backgroundColor: deckColor,
            marginHorizontal: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: { xs: "2%", md: "2%" },
            position: "relative",
          }}
        >
       
          <Typography
            variant="caption"
            sx={{ fontSize: ".7rem", color: "#fff" }}
          >
            Pick Color
          </Typography>
        </Button> */}
      </Grid>

      <Grid container spacing={2}>
        <Grid
          item
          container
          xs={12}
          md={6}
          sx={{
            order: { xs: 1, md: 2 },
            position: "relative",
            justifyContent: "center",
          }}
        >
          {/* Header for Deck Cards */}
          <Grid container spacing={1} md={12}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                sx={{
                  mb: 1,
                  color: "#fff",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                Deck Cards {newDeck.length} / {slots.length}
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                position: "relative",
                left: { xs: "30%", md: 0 },
              }}
            ></Grid>
          </Grid>
          {/* Deck Cards Container */}
          {/* Mobile Layout: two rows, horizontally scrollable */}
          <Box
            ref={deckCardsRef}
            sx={{
              display: { xs: "grid", md: "none" },
              gridAutoFlow: "column",
              gridTemplateRows: "repeat(2, 1fr)",
              columnGap: 1,
              rowGap: { xs: 1, md: 0 },
              height: { xs: "85%", md: "45vh" },
              width: { xs: "85%", md: "100%" },
              overflowX: "auto",
              overflowY: "hidden",
              p: 2,
              background: "#ffffff99",
              borderRadius: 2,
              scrollbarWidth: "none",
              position: "relative",
              top: { xs: -10, md: 0 },
            }}
          >
            {slots.map((card, index) => (
              <Box
                key={index}
                sx={{
                  width: { xs: "20dvw", md: "30%" },
                  aspectRatio: "2.5 / 3.5",
                  position: "relative",
                  marginRight: { xs: 2, md: 0 },
                }}
                // onClick={() => card && handleRemoveCard(card)}
                onClick={() =>
                  card && removeFromDeck(card, newDeck, setNewDeck)
                }
              >
                {card ? (
                  showCharacter ? (
                    <CharacterCard {...card} />
                  ) : (
                    <InfinityCard
                      {...card}
                      containerHeight={
                        window.innerWidth > 900
                          ? window.innerHeight * 0.5
                          : window.innerHeight * 0.19
                      }
                      heightPer={80}
                    />
                  )
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      aspectRatio: "2.5 / 3.5",
                      border: "1px dashed grey",
                      borderRadius: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 1,
                    }}
                  >
                    <Typography variant="body2">Slot {index + 1}</Typography>
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          {/* Desktop Layout for Deck Cards */}
          <Box
            ref={deckCardsRef}
            sx={{
              display: { xs: "none", md: "block" },
              height: "70vh",
              overflowY: "auto",
              p: 3,
              background: "#ffffff99",
              borderRadius: 2,
              scrollbarWidth: "none",
            }}
          >
            <Grid container spacing={1} columns={5}>
              {slots.map((card, index) => (
                <Grid
                  item
                  xs={1}
                  key={index}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  {card ? (
                    <Box
                      sx={{ width: "100%", aspectRatio: "2.5 / 3.5" }}
                      onClick={() => removeFromDeck(card, newDeck, setNewDeck)}
                    >
                      {showCharacter ? (
                        <CharacterCard {...card} />
                      ) : (
                        <InfinityCard
                          {...card}
                          containerHeight={
                            window.innerWidth > 900
                              ? window.innerHeight * 0.18
                              : window.innerHeight * 0.25
                          }
                          heightPer={100}
                        />
                      )}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        aspectRatio: "2.5 / 3.5",
                        border: "1px dashed grey",
                        borderRadius: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 1,
                      }}
                    >
                      <Typography variant="body2">Slot {index + 1}</Typography>
                    </Box>
                  )}
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        {/* Available Cards Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            order: { xs: 2, md: 1 },
            position: "relative",
          }}
        >
          {/* Header for Available Cards */}
          <Grid container spacing={1} md={12}>
            <Grid
              item
              md={6}
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                marginTop: { xs: 4, md: 0 },
                // top: { xs: -70, md: 0 },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  // mb: { xs: 0, md: 0 },
                  color: "#fff",
                  fontSize: { xs: "0.8rem", md: "1.2rem" },
                }}
              >
                Available Cards
              </Typography>

              <Typography variant="body2" sx={{ color: "#fff", ml: 1 }}>
                Infinity Cards
              </Typography>
            </Grid>
          </Grid>
          <Box
            ref={availableCardsRef}
            sx={{
              height: "70dvh",
              overflowY: "hidden",
              p: { xs: 1, md: 3 },
              background: "#ffffff50",
              borderRadius: 2,
              scrollbarWidth: "none",
              position: "relative",
              justifyContent: "center",
              //   top: {
              //     xs: -80,
              //     md: 0,
              //   },
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                order: { xs: 2, md: 1 },
                position: "relative",
                // top: { xs: -30, md: 0 },
              }}
            >
              {/* Header for Available Cards */}

              <Box
                ref={availableCardsRef}
                sx={{
                  height: { xs: "70vh", md: "70vh" },
                  overflowY: "auto",
                  // p: { xs: 0, md: 0 },
                  // background: "#ffffff50",
                  borderRadius: 2,
                  scrollbarWidth: "none",
                  position: "relative",
                  //   top: { xs: 40, md: 0 },
                  width: "100%",
                  left: { xs: 8, md: 0 },
                }}
              >
                <Grid
                  container
                  spacing={{ xs: 1, md: 3 }}
                  sx={{ height: "70%" }}
                >
                  {availableCards &&
                    availableCards.map((card, index) => {
                      const ownedCount = card.amountOwned;
                      const maxCount = card.max;
                      const count = cardCount[card.id] || 0;
                      const isMaxed =
                        newDeck.length >= 40 ||
                        (card.max !== undefined && count >= card.max) ||
                        (card.amountOwned !== undefined &&
                          count >= card.amountOwned);

                      return (
                        <Grid item xs={4} key={card.id}>
                          <Box
                            sx={{
                              width: { xs: "80%", md: "90%" },
                              cursor: "pointer",
                              borderRadius: "12px",
                              position: "relative",
                              border:
                                character?.name === card.name
                                  ? "4px solid #fff"
                                  : "none",
                              background:
                                character?.name === card.name
                                  ? "#fff"
                                  : "transparent",
                            }}
                          >
                            {isMaxed && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  position: "absolute",
                                  top: "53%",
                                  left: "53%",
                                  transform: "translate(-50%, -50%)",
                                  width: "103%",
                                  height: "103%",
                                  backgroundColor: "rgba(0, 0, 0, 0.65)",
                                  zIndex: 10,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 3,
                                  containerType: "inline-size",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "8cqw",
                                  }}
                                >
                                  MAX REACHED
                                </Typography>
                              </Box>
                            )}

                            <InfinityCard
                              {...card}
                              showAmountOwned={true}
                              onClick={() => {
                                // console.log("clicked card", card, newDeck);
                                addToDeck(
                                  cards,
                                  card,
                                  newDeck,
                                  setNewDeck,
                                  setMessage,
                                  setError
                                );
                              }}
                              containerHeight={
                                window.innerWidth > 900
                                  ? window.innerHeight * 0.5
                                  : window.innerHeight * 0.25
                              }
                            />
                          </Box>
                        </Grid>
                      );
                    })}
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Grid>

      {showColorPicker && (
        <Box
          style={{
            position: "absolute",
            top: window.innerWidth >= 900 ? "30%" : "15%",
            left: window.innerWidth >= 900 ? "30%" : "5%",
            right: "10%",
            backgroundColor: "#fff",
            borderRadius: 10,
            padding: 20,
            zIndex: 9999,
            elevation: 10, // for Android shadow
            width: window.innerWidth >= 900 ? "30%" : "80%",
          }}
        >
          <Typography
            style={{
              fontWeight: "bold",
              fontSize: 18,
              marginBottom: 10,
              textAlign: "center",
            }}
          >
            Pick a Deck Color
          </Typography>
          <Box
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {[
              "#0070f7",
              "#ef169c",
              "#f38153",
              "#4CAF50",
              "#9C27B0",
              "#FFEB3B",
              "#FF5722",
              "#795548",
              "#00BCD4",
              "#8BC34A",
              "#E91E63",
              "#03A9F4",
              "#CDDC39",
              "#FF9800",
              "#673AB7",
              "#3F51B5",
              "#009688",
              "#FFC107",
              "#9E9E9E",
              "#607D8B",
              "#D500F9",
              "#00E676",
              "#FF3D00",
              "#A1887F",
              "#B2FF59",
            ].map((color) => (
              <Button
                key={color}
                onClick={() => {
                  setDeckColor(color);
                  setShowColorPicker(false);
                }}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 20,
                  margin: 5,
                  backgroundColor: color,
                  borderWidth: 2,
                  borderColor: "#000",
                }}
              />
            ))}
          </Box>
          <NeoButton
            text="Cancel"
            onClick={() => setShowColorPicker(false)}
            color="$secondary"
          />
        </Box>
      )}
    </Box>
  );
};

export default DeckBuilder;
